import React from 'react'
import { useSelector } from 'react-redux'
import { AppState } from '@news-mono/web-common'
import { PageProps } from 'page-lifecycle-provider'

interface AuthEventDetails {
    gigyaId: string
    loginProvider: string
    socialProviders: string
    isLoggedIn: boolean
    occupantId: string | undefined
    entitlements: string[]
    subscriptionType: string
    subscriptionId?: string
}

export interface AuthGtmShape {
    gigya: string
    loginProvider: string
    socialProviders: string
    loggedInStatus: string
    dti: string | undefined
    entitlements: string[]
    subscriptionType: string
}

export const UserAnalytics: React.FC = () => {
    const {
        gigyaId,
        isLoggedIn,
        loginProvider,
        socialProviders,
        occupantId,
        entitlements,
        subscriptionType,
        subscriptionId,
    } = useSelector((state: AppState) => state.authentication)

    return (
        <PageProps
            pageProperties={toGtmShape({
                gigyaId,
                loginProvider,
                socialProviders,
                isLoggedIn,
                occupantId,
                entitlements,
                subscriptionType,
                subscriptionId,
            })}
        />
    )
}

UserAnalytics.displayName = 'InternalUserAnalytics'
export function toGtmShape(event: AuthEventDetails): AuthGtmShape {
    return {
        gigya: event.gigyaId,
        loginProvider: event.loginProvider,
        socialProviders: event.socialProviders,
        loggedInStatus: getLoggedInStatus(event.isLoggedIn),
        dti: event.occupantId || '',
        entitlements: event.entitlements,
        subscriptionType: event.subscriptionType,
    }
}
export function getLoggedInStatus(isLoggedIn: boolean) {
    return isLoggedIn ? 'Logged in' : 'Logged out'
}
